const Index = () => import('./index.vue');
const Details = () => import('./details.vue');

export default [
    {
        path: '/cancel-sale',
        component: Index
    },
    {
        path: '/cancel-sale/:id',
        component: Details
    }
];